import { render } from "./Navbar.vue?vue&type=template&id=a0ca3992&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=ts"
export * from "./Navbar.vue?vue&type=script&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=a0ca3992&lang=scss&scoped=true"
import "./Navbar.vue?vue&type=style&index=1&id=a0ca3992&lang=css"
script.render = render
script.__scopeId = "data-v-a0ca3992"

export default script